import { getDictListByTemplate, switchEditMode } from "../api/dict"
import { FieldType } from "../type"
import { DictData, DictTemplateCodeEnum } from "./type"

export const getDictTableData = async (templateCode: string) => {
    const resTable = await getDictListByTemplate({ templateCode })
    const newData = resTable?.data ? resTable.data : resTable
    // 排序 sortNumber 字段，递增
    newData.sort((a, b) => a.sortNumber - b.sortNumber)
    // extraAttrs 里面的属性挂载到表格上面以 extra_开头
    newData.forEach(item => {
        if (item.dictId) {
            item.id = item.dictId
        }
        (item.extraAttrs || []).forEach(attr => {
            const { attrCode, attrVals } = attr
            // attr.attrVals.forEach(val => {
            //     item[`extra_${attr.attrCode}`] = val.value
            // })
            if (attrCode === 'zdlx') {
                item.attr_zdlx = attrVals[0].key
            }
            if (attrCode === 'sfcode') {
                item.attr_sfcode = attrVals[0].key
            }
            if (attrCode === 'nr') {
                // 枚举项，转成 [{ label, value }] 结构
                item.attr_nr = attrVals?.map(val => ({
                    label: val.value,
                    value: val.key
                })) || []
            }
        })
    })

    return newData as any[]
}

// 切换字典编辑模式
export const switchDictEditMode = async (data: any) => {
    const res = await switchEditMode(data)
    return res
}